import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('country-zip-code-select', () => import(/* webpackMode: "lazy" */'./country-zip-code-select'));
